<template>
  <div class="requirement-card">
    <div class="requirement-details">
      <div class="attribute-badge">
        {{ requirement.attribute }}
      </div>
      <div class="requirement-text">
        {{ requirement.text }}
      </div>
    </div>
    <div class="actions">
      <v-spacer></v-spacer>
      <v-btn @click="handleEdit" variant="text" color="primary">
        <v-icon left>mdi-pencil</v-icon>
        Edit
      </v-btn>
      <v-btn color="error" @click="handleDelete" variant="text">
        <v-icon left>mdi-delete</v-icon>
        Delete
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "RequirementCard",

  props: {
    requirement: {
      type: Object,
      required: true,
    },
  },

  emits: ["edit", "delete"],

  methods: {
    handleEdit() {
      this.$emit("edit", this.requirement);
    },

    handleDelete() {
      this.$emit("delete", this.requirement.id);
    },
  },
};
</script>

<style scoped>
.requirement-card {
  transition: all 0.2s ease;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--contrastColor);
  padding: 12px 0;
}
.requirement-details {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.attribute-badge {
  padding: 4px 12px;
  background-color: var(--contrastColor);
  color: white;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  white-space: nowrap;
  min-width: 120px;
  text-align: center;
}

.requirement-text {
  flex: 1;
  color: var(--contrastColor) !important;
  line-height: 1.4;
  word-break: break-word;
}

.actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 12px;
}

@media (max-width: 1000px) {
  .requirement-card {
    flex-direction: column;
  }
  .requirement-details {
    flex-direction: column;
    gap: 8px;
  }
  .attribute-badge {
    min-width: auto;
  }
}
</style>
